<template>
    <div v-loading="loading">
        <div class="search-ctn" style="margin-bottom: 10px">
            <div class="search-ctn-left">
                <el-button size="small" class="btn-primary" @click="setTitles()">添加单头设置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="dataList" border="" style="width: 100%; margin-bottom: 10px" min-height="530px">
                <el-table-column fixed show-overflow-tooltip label="单头" prop="OrderTitle"> </el-table-column>
                <el-table-column show-overflow-tooltip prop="FootNote" label="脚注"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">{{ scope.row.OrderType | typeHandle }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="状态">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="scope.row.State == 0" title="停用" size="mini" type="text" style="color: #c89932" @click="changeState(scope.row)">停用</el-button>
                            <el-button v-if="scope.row.State == 1" title="启用" size="mini" type="text" style="color: green" @click="changeState(scope.row)">启用</el-button>
                            <el-button title="编辑" size="mini" type="text" @click="setTitles(scope.row)">编辑</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            id="order-title-dialog"
            custom-class="edit-item-dialog"
            style="margin-left: -170px"
            :title="dialogTitle"
            :visible.sync="editVisible"
            width="500px"
            append-to-body
        >
            <div class="dialog-content" v-if="editVisible" v-loading="diaLoading">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="单头">
                        <el-input class="search-item" size="small" v-model="submitData.OrderTitle" placeholder="请输入单头"></el-input>
                    </el-form-item>
                    <el-form-item label="脚注">
                        <el-input
                            type="textarea"
                            maxlength="500"
                            :rows="4"
                            show-word-limit
                            class="search-item"
                            size="small"
                            v-model="submitData.FootNote"
                            placeholder="请输入脚注"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="单据类型">
                        <el-select size="small" class="search-item" style="width: 100%" v-model="submitData.OrderType" :disabled="isDisable">
                            <el-option label="请选择" value=""></el-option>
                            <el-option label="销售单" :value="0"></el-option>
                            <el-option label="采购单" :value="1"></el-option>
                            <el-option label="销售退货单" :value="2"></el-option>
                            <el-option label="采购退货单" :value="3"></el-option>
                            <el-option label="报价单" :value="4"></el-option>
                            <el-option label="询价单" :value="5"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="submit">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['WarehouseId'],
    data() {
        return {
            loading: false,
            diaLoading: false,
            editVisible: false,
            dataList: [],
            isDisable: false,
            dialogTitle: '',
            submitData: {
                Id: '',
                OrderTitle: '',
                FootNote: '',
                OrderType: '',
                WarehouseId: this.WarehouseId
            }
        };
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常';
            } else if (value == 1) {
                return '已停用';
            } else if (value == 2) {
                return '已删除';
            }
        },
        typeHandle(value) {
            if (value == 0) {
                return '销售单';
            } else if (value == 1) {
                return '采购单';
            } else if (value == 2) {
                return '销售退货单';
            } else if (value == 3) {
                return '采购退货单';
            } else if (value == 4) {
                return '报价单';
            } else if (value == 5) {
                return '询价单';
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            if (that.WarehouseId) {
                that.loading = true;
                that.$util
                    .axiosGet({
                        url: '/api/EntpWarehouse/GetEntpWarehouseTitleSets',
                        data: { WarehouseId: that.WarehouseId }
                    })
                    .then(res => {
                        if (res.data) {
                            that.dataList = res.data;
                        }
                        that.loading = false;
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            }
        },
        setTitles(item) {
            if (item) {
                this.dialogTitle = '编辑单头';
                this.submitData.Id = item.Id;
                this.submitData.OrderTitle = item.OrderTitle;
                this.submitData.OrderType = item.OrderType;
                this.submitData.FootNote = item.FootNote;
                this.isDisable = true;
            } else {
                this.dialogTitle = '新增单头';
                this.submitData = {
                    Id: '',
                    OrderTitle: '',
                    FootNote: '',
                    OrderType: '',
                    WarehouseId: this.WarehouseId
                };
                this.isDisable = false;
            }
            this.editVisible = true;
        },
        submit() {
            let that = this;
            if (that.submitData.OrderType === '') {
                that.$util.warningMsg('请选择单据类型');
                return;
            }
            if (!that.submitData.OrderTitle) {
                that.$util.warningMsg('请输入单头内容');
                return;
            }
            that.diaLoading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpWarehouse/SaveEntpWarehouseTitleSets',
                    data: that.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$util.successMsg(res.errmsg);
                        that.getTableData();
                        that.editVisible = false;
                    } else this.$util.errorMsg(res.errmsg);
                })
                .catch(() => {})
                .finally(() => {
                    that.diaLoading = false;
                });
        },
        changeState(item) {
            let that = this;
            if (item) {
                that.diaLoading = true;
                that.$util
                    .axiosPost({
                        url: `/api/EntpWarehouse/ChangeTitleSetsState?id=${item.Id}`
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg(res.errmsg);
                            that.getTableData();
                        } else this.$util.errorMsg(res.errmsg);
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.diaLoading = false;
                    });
            }
        }
    }
};
</script>
<style lang="less" scoped>
#order-title-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .edit-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
